import {alias, createModelSchema, list} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";

import {RewardModel} from "../reward/RewardModel";
import {ItemKey} from "../item/core/ItemKey";
import {DiscoveryMode} from "./DiscoveryMode";

export class DiscoveryModel extends BaseObject {

    static RARITY = new Map([
      [0, 'NONE'],
      [1, 'LOW'],
      [2, 'MEDIUM'],
      [3, 'HIGH'],
    ]);

    constructor() {
        super();

        this._key = null;
        this._name = null;

        this._mode = DiscoveryMode.DEFAULT;
        this._item = null;
        this._reward = null;

        this._extend = false;
        this._extendReward = null;
        this._recipes = [];

        this._rarity = 0;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get mode() {
        return this._mode;
    }

    set mode(value) {
        this._mode = value;
    }

    get item() {
        return this._item;
    }

    set item(value) {
        this._item = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get extend() {
        return this._extend;
    }

    set extend(value) {
        this._extend = value;
    }

    get extendReward() {
        return this._extendReward;
    }

    set extendReward(value) {
        this._extendReward = value;
    }

    get recipes() {
        return this._recipes;
    }

    set recipes(value) {
        this._recipes = value;
    }

    get rarity() {
        return this._rarity;
    }

    set rarity(value) {
        this._rarity = value;
    }

    valid() {

        if (!this.item || !this.item.valid() || this.item.any()) {
            return false;
        }

        if (!this.reward || this.reward.empty()) {
            return false;
        }

        if (this.reward && !this.reward.valid()) {
            return false;
        }

        if (this.extend && DiscoveryMode.DEFAULT.equal(this.mode)) {
            return false;
        }

        if (this.extendReward && !this.extendReward.valid()) {
            return false;
        }

        if(this.rarity < 0 || this.rarity > 3) {
            return false;
        }

        if (this.recipes && this.recipes.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new DiscoveryModel());
        } else if (target instanceof DiscoveryModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(DiscoveryModel, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _mode: alias("mode", DiscoveryMode.schema()),

    _item: alias("item", ItemKey.schema()),
    _reward: alias("reward", RewardModel.schema()),
    _extend: alias("extend", Schema.primitive()),
    _extendReward: alias("extend_reward", RewardModel.schema()),

    _recipes: alias("recipes", list(ItemKey.schema())),
    _rarity: alias("rarity", Schema.primitive()),
});